import { useEffect, useState } from "react";
import {
    DEFAULT_DISCORD_INVITE_URL,
    fetchPublicDiscordInviteUrl,
} from "../public-site/discordInviteUrl";

export default function useLobbyPublicMeta({ basePath, user }) {
    const [discordInviteUrl, setDiscordInviteUrl] = useState(
        DEFAULT_DISCORD_INVITE_URL,
    );
    const [founderProgress, setFounderProgress] = useState(null);
    const [referralCode, setReferralCode] = useState(null);

    useEffect(() => {
        fetchPublicDiscordInviteUrl(basePath)
            .then((url) => setDiscordInviteUrl(url))
            .catch(() => { });
    }, [basePath]);

    useEffect(() => {
        fetch(`${basePath}/api/v1/founder/progress`, { credentials: "include" })
            .then((r) => r.json())
            .then((data) => {
                if (data?.ok) setFounderProgress(data);
            })
            .catch(() => { });
    }, [basePath]);

    useEffect(() => {
        if (!user?.userId) return;
        fetch(`${basePath}/api/v1/referral/my-code`, { credentials: "include" })
            .then((r) => r.json())
            .then((data) => {
                if (data?.ok && (data?.referralCode || data?.code))
                    setReferralCode(data.referralCode || data.code);
            })
            .catch(() => { });
    }, [basePath, user?.userId]);

    return {
        discordInviteUrl,
        founderProgress,
        referralCode,
    };
}
